/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum PortalUserStatuses {
    Unknown,
    Enabled,
    Disabled,
}
